<template>
  <a-flex gap="middle" align="center" justify="center">
    <a-tooltip title="Удалить товар">
      <a-button class="icon-button danger" @click="showConfirmDelete">
        <DeleteOutlined />
      </a-button>
    </a-tooltip>
  </a-flex>
</template>

<script setup lang="ts">
import { DeleteOutlined } from "@ant-design/icons-vue";
import {
  type CombineProductsBySizeTableItem,
  useCombineProductsBySize,
} from "@/stores/product/combineProducts/combineProductsBySize/combine-products-by-size.store";
import type { BaseProductDto } from "@/types/product/productTypes";
import { showConfirm } from "@/tools/ConfirmationDialog";
import Product from "@/api/classes/product/product";
import { createNotification } from "@/tools/notification";

const props = defineProps<{ record: CombineProductsBySizeTableItem }>();

const combineProductsBySizeStore = useCombineProductsBySize();

const showConfirmDelete = () => {
  showConfirm({
    title: "Вы действительно хотите удалить товар из каталога?",
    onOk: async () => {
      await deleteProduct(props.record.id);
    },
  });
};

const deleteProduct = async (id: BaseProductDto["id"]) => {
  try {
    await Product.deleteProduct([id]);

    createNotification("success", "Товар успешно удален");
    await combineProductsBySizeStore.loadData();
  } catch (error) {
    createNotification("error", "Произошла ошибка при удалении товара");
  }
};
</script>

<style scoped lang="scss">
.icon-button {
  padding: 0;
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;

  &.danger {
    color: #ff5226;
  }
}
</style>
